<div class="note-list-header">
  <div [ngClass]="config.titleColorClass" class="note-title">{{ config.title | translate }}</div>
  <ion-button [appAccountCanViewExcept]="['viewer']" (click)="addNote()" class="page-button" color="secondary">{{ "SHARED.Add_Note" | translate }}</ion-button>
</div>

<app-note-card *ngFor="let note of config.notes"
                      [avatarUrl]="note.userImg"
                      [name]="note.name"
                      [text]="note.data"
                      [language]="note.language"
                      [translations]="note.translations"
                      [type]="note.type"
                      [time]="note.time"></app-note-card>

<div *ngIf="config.showEmptyMessage && config.notes.length === 0"
     class="empty-message">{{ 'SHARED.Be_The_First_To_Add_Note' | translate }}</div>
